import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';

export const Route = createFileRoute('/legal/privacy')({
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy — AITOS Labs LLC</title>
        <meta
          name="description"
          content="Privacy Policy for AITOS Labs LLC. Compliant with GDPR (EU) and CCPA (California)."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://aitos.app/legal/privacy" />
      </Helmet>

      <p className="text-purple-400 text-xs tracking-widest mb-4">PRIVACY</p>
      <h1>Privacy Policy</h1>
      <p>
        <strong>Last updated:</strong> May 2026
      </p>

      <h2>Data controller</h2>
      <address className="not-italic">
        AITOS Labs LLC
        <br />
        30 N Gould St Ste N
        <br />
        Sheridan, WY 82801
        <br />
        United States
        <br />
        Email: <a href="mailto:hi@aitos.app">hi@aitos.app</a>
      </address>

      <h2>What we collect</h2>
      <ul>
        <li>
          <strong>Contact form submissions:</strong> name, work email, company / brand name, brand
          URL, intent, message, marketing consent.
        </li>
        <li>
          <strong>Analytics:</strong> standard web analytics (page views, anonymized IP, referrer).
        </li>
      </ul>

      <h2>How we use it</h2>
      <ul>
        <li>To respond to inquiries (Audit, Operations, Investor, Partnership, Press, Other).</li>
        <li>To improve the AITOS website and operations.</li>
        <li>If consent is given, occasional updates from AITOS Labs LLC.</li>
      </ul>

      <h2>GDPR (EU)</h2>
      <p>If you are in the European Economic Area, you have the right to:</p>
      <ul>
        <li>Access the personal data we hold about you.</li>
        <li>Request correction or deletion.</li>
        <li>Object to processing or request portability.</li>
        <li>Withdraw consent at any time.</li>
      </ul>
      <p>
        Cross-border data transfers from the EU to the US rely on Standard Contractual Clauses
        (SCCs) where applicable.
      </p>

      <h2 id="ccpa">CCPA (California, USA)</h2>
      <p>If you are a California resident, you have the right to:</p>
      <ul>
        <li>Know what personal information we collect about you.</li>
        <li>Request deletion of your personal information.</li>
        <li>Opt out of the sale or sharing of your personal information.</li>
      </ul>
      <p>
        AITOS Labs LLC does not sell personal information. To exercise any CCPA right, email{' '}
        <a href="mailto:hi@aitos.app">hi@aitos.app</a> with the subject line "CCPA Request".
      </p>

      <h2>Data retention</h2>
      <p>
        Contact form submissions are retained for as long as we are in active conversation, plus a
        reasonable archival period for business records. You may request deletion at any time.
      </p>

      <h2>Cookies</h2>
      <p>
        We do not currently set marketing cookies. If we add analytics or marketing cookies, a
        cookie banner will appear and your consent will be requested.
      </p>

      <h2>Changes</h2>
      <p>
        We may update this Privacy Policy. Material changes will be reflected in the "Last updated"
        date at the top.
      </p>

      <h2>Contact</h2>
      <p>
        For privacy questions, email <a href="mailto:hi@aitos.app">hi@aitos.app</a>.
      </p>
    </>
  );
}
